module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-chapter element-with-heading",
    attrs: {
      "id": "chapter-2"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "chapter-2-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-title-is-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("2")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "chapter-2-text"
    }
  }, [_c('div', {
    staticClass: "alignment-block alignment-block-align-center"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_c('b', [_vm._v("Shankill Road,")])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_c('b', [_vm._v("Belfast, Northern Ireland")])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_c('b', [_vm._v("March 1970")])])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("T")]), _vm._v("he red brick back-yard wall of McGrew’s Pub looked daunting to such a small boy.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Looming above him and bristling with broken shards and slivers from the multi-coloured glass of bleach bottles and jam jars.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Cemented deep in there.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Jagging up like shark fins and crooked crocodile teeth.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("To repel intruders and ten-year-old misfits in pursuit of lost footballs.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Eban Winston Barnard was eleven.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("And fully possessed of his reasons to climb.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-019cea2b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter-002.vue
// module id = 81
// module chunks = 0